import React from 'react';
import './Header.css';

function Header() {
    const handleClick = (event) => {
        event.preventDefault();
        const targetId = event.target.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        targetElement.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <header className="lg:mx-16 sm:mx-2 py-4">
            <div className="d-flex justify-between">
                <div className="d-flex">
                    <img
                        src={require('../assets/images/LOGO.svg').default}
                        alt="logo"
                        className="cursor-pointer"
                        onClick={() => window.location.href = "/"}
                    />
                    <div className="hidden lg:block my-auto">
                        <nav className="d-flex gap-4 ms-4">
                            <a href="#home" className="nav-link my-auto" onClick={handleClick}>
                                خانه
                            </a>
                            <a href="#services" className="nav-link my-auto" onClick={handleClick}>
                                ویژگی‌ها
                            </a>
                            <a href="#about_us" className="nav-link my-auto" onClick={handleClick}>
                                درباره ما
                            </a>
                            <a href="#contact_us" className="nav-link my-auto" onClick={handleClick}>
                                تماس با ما
                            </a>
                        </nav>
                    </div>
                </div>
                <div className="gap-2 d-flex my-auto">
                    <button
                        className="btn text-nowrap text-white"
                        style={{ backgroundColor: '#0156F9', width: '140px' }}
                    >
                        <a href="https://auth.chatyar.ir/login" target="_blank" rel="noreferrer" className="text-white text-decoration-none">
                            ورود
                        </a>
                    </button>
                    <button
                        className="btn text-nowrap"
                        style={{ backgroundColor: 'white', width: '140px', text: '#0156F9', border: '1px solid #0156F9' }}
                    >
                        <a href="https://auth.chatyar.ir/signup" target="_blank" rel="noreferrer" className="text-decoration-none">
                            ثبت نام
                        </a>
                    </button>
                </div>
            </div>
        </header>
    );
}

export default Header;
